import {
  call,
  put,
  all,
  spawn,
  takeEvery,
  takeLatest,
} from 'redux-saga/effects';
import { toast } from '@cashfree-intl/coherent';

import {
  UPSERT_MERCHANT_REG_DETAILS_URL,
  GET_REG_DETAILS_URL,
  FRESHDESK_REDIRECT_URL,
  GET_MERCHANT_DETAILS_URL,
  CLOSE_BANNER_URL,
} from 'constants/url';

import request, { makeFetchRequest } from '../../utils/request';
import { showToast } from '../Toast/actions';

import {
  fetchProductStatusSuccess,
  fetchTestTokenFromProdSuccess,
  resendEmailVerificationSuccess,
  validateTokenSuccess,
  disableLoaderAction,
  updateGammaToken,
  fetchPayoutDashboardConfigSuccess,
  updateSubscriptionStatus,
  setAMDetails,
  fetchQuickLinksSuccess,
  generateHcFormSucccess,
  enableLoaderAction,
  getFormDataSuccess,
  openHcFormAction,
  getPayoutProtectInsightsSuccessAction,
  getPayoutProtectActiveStatusSuccessAction,
  getRiskShieldActiveStatusSuccessAction,
} from './actions';
import {
  PRODUCT_STATUS_URL,
  TEST_TOKEN_FROM_PROD_URL,
  RESEND_EMAIL_VERIFICATION_URL,
  VALIDATE_TOKEN_URL,
  FETCH_GAMMA_TOKEN_URL,
  FETCH_PAYOUTS_DASHBOARD_CONFIG_URL,
  REDEEM_VOUCHER_URL,
  GET_SUBSCRIPTION_STATUS_URL,
  QUICK_LINKS_URL,
  HC_FORM,
  PROD,
  PROD_TEST,
  CUSTOM_BASE_PATH_TYPES,
} from '../../utils/constants';
import {
  FETCH_PRODUCT_STATUS,
  FETCH_TEST_TOKEN_FROM_PROD,
  RESEND_EMAIL_VERIFICATION,
  ACTIVATE_PRODUCTS,
  VALIDATE_TOKEN,
  FETCH_GAMMA_TOKEN,
  FETCH_PAYOUT_DASHBOARD_CONFIG,
  REDEEM_VOUCHER,
  GET_SUBSCRIPTION_STATUS,
  SUBSCRIBE_WHATSAPP,
  WHATSAPP_CONSENT,
  FRESHDESK_REDIRECT,
  FETCH_BANNERS,
  FETCH_BANNERS_URL,
  GET_MERCHANT_DETAILS,
  FETCH_PRODUCT_CARDS,
  FETCH_PRODUCT_CARDS_URL,
  QUICK_ACTIVATE_PRODUCT,
  QUICK_ACTIVATE_PRODUCT_URL,
  ACTIVATE_PRODUCTS_URL,
  PARTNER_CONSENT,
  PARTNER_TNC,
  PARTNER_CONSENT_URL,
  PARTNER_TNC_URL,
  GET_ACCOUNT_MANAGER_DETAILS,
  AM_DETAILS_URL,
  FETCH_AGGREGATED_PRODUCT_STATUS,
  LIVE_PRODUCT_STATUS_URL,
  FETCH_QUICK_LINKS,
  PRODUCT_ACTIVATE_URL,
  ACTIVATE_ECOM_PRODUCT_ACTION,
  FETCH_HELPCENTER_FORM,
  DASHBOARD,
  CLOSE_BANNER,
  PAYOUT_PROTECT_INSIGHTS,
  PAYOUT_PROTECT_ACTIVE_STATUS,
  PAYOUT_PROTECT_ACTIVE_STATUS_URL,
  PAYOUT_PROTECT_INSIGHTS_URL,
  ACTIVATE_PAYOUT_PROTECT_URL,
  ACTIVATE_PAYOUT_PROTECT,
  RISK_SHIELD_ACTIVE_STATUS_URL,
  RISK_SHIELD_ACTIVE_STATUS,
  ACTIVATE_RISKSHIELD,
  ACTIVATE_RISKSHIELD_URL,
} from './constants';
import { sortAccountManagerList } from './helpers';

export function* fetchProductStatusData() {
  try {
    const requestURL = PRODUCT_STATUS_URL;
    const data = yield call(request, requestURL);
    // update the redux state
    yield put(fetchProductStatusSuccess(data));
  } catch (err) {
    yield put(disableLoaderAction());
    yield put(showToast(err));
  }
}

export function* validateToken() {
  try {
    const requestURL = VALIDATE_TOKEN_URL;
    const data = yield call(request, requestURL);
    // update the redux state
    yield put(validateTokenSuccess(data));
  } catch (err) {
    yield put(disableLoaderAction());
    yield put(showToast(err));
  }
}

export function* fetchTestTokenFromProdData() {
  try {
    const requestURL = TEST_TOKEN_FROM_PROD_URL;
    const data = yield call(request, requestURL);
    // update the redux state
    yield put(fetchTestTokenFromProdSuccess(data));
  } catch (err) {
    yield put(disableLoaderAction());
    yield put(showToast(err));
  }
}

export function* resendEmailVerificationData() {
  try {
    const requestURL = RESEND_EMAIL_VERIFICATION_URL;
    const data = yield call(request, requestURL);
    // update the redux state
    yield put(resendEmailVerificationSuccess(data));
  } catch (err) {
    yield put(
      resendEmailVerificationSuccess({
        message: 'Email has already been verified',
        status: 'ERROR',
      }),
    );
    yield put(disableLoaderAction());
    yield put(showToast(err));
  }
}

export function* activateProduct({ data }) {
  try {
    const { productNames, cb } = data;
    const { url, method } = ACTIVATE_PRODUCTS_URL;
    const options = {
      method,
      body: JSON.stringify({
        productNames,
        productSelectionSource: DASHBOARD,
      }),
      queryString: { addProduct: true },
    };
    yield call(request, url, options);
    if (cb) cb();
  } catch (err) {
    yield put(showToast(err));
  } finally {
    yield put(disableLoaderAction());
  }
}

export function* fetchGammaToken({ data: { cb } }) {
  try {
    const { url, method } = FETCH_GAMMA_TOKEN_URL;
    const response = yield call(request, url, { method });
    yield put(updateGammaToken(response));
  } catch (e) {
    yield put(disableLoaderAction());
    yield put(showToast(e));
  } finally {
    if (cb) cb();
  }
}

export function* fetchPayoutDashboardConfigData() {
  try {
    const requestURL = FETCH_PAYOUTS_DASHBOARD_CONFIG_URL;
    const data = yield call(request, requestURL);
    // update the redux state
    yield put(fetchPayoutDashboardConfigSuccess(data));
  } catch (err) {
    yield put(disableLoaderAction());
    yield put(showToast(err));
  }
}
export function* getSubscriptionStatus({ envCall }) {
  try {
    const data = yield call(request, GET_SUBSCRIPTION_STATUS_URL, { envCall });
    yield put(updateSubscriptionStatus(data));
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error(err);
    yield put(updateSubscriptionStatus({}));
    yield put(disableLoaderAction());
  }
}

export function* redeemVoucher({
  data: { cbSuccess, cbError, actions, ...body },
}) {
  try {
    const { url, method } = REDEEM_VOUCHER_URL;
    const options = {
      body: JSON.stringify(body),
      method,
    };
    const response = yield call(request, url, options);
    cbSuccess(response);
  } catch (err) {
    if (actions) actions.setSubmitting(false);
    cbError(err.errorMeta.message);
  }
}

export function* subscribeWhatsapp({ data: { cbSuccess, actions, ...body } }) {
  try {
    const { url, method } = UPSERT_MERCHANT_REG_DETAILS_URL;
    const options = {
      body: JSON.stringify(body),
      method,
    };
    yield call(request, url, options);
    cbSuccess();
    if (actions) actions.setSubmitting(false);
  } catch (err) {
    if (actions) actions.setSubmitting(false);
    yield put(showToast(err));
  }
}
export function* checkWhatsappConsentData({ data: { cbSuccess } }) {
  try {
    const { url, method } = GET_REG_DETAILS_URL;
    const data = yield call(request, url, { method });
    cbSuccess(data.regDetails);
  } catch (err) {
    yield put(showToast(err));
  }
}

export function* checkPartnerConsent({ data: { successCb, errorCb } }) {
  try {
    const { url, method } = PARTNER_CONSENT_URL;
    const data = yield call(request, url, { method });
    successCb(data);
  } catch (err) {
    errorCb();
  }
}

export function* partnerTnc({ data: { cb, ...body } }) {
  try {
    const { url, method } = PARTNER_TNC_URL;
    const options = {
      body: JSON.stringify(body),
      method,
    };
    yield call(request, url, options);
    cb();
  } catch (err) {
    yield put(showToast(err));
  }
}

export function* freshdeskRedirect({ data }) {
  const { cb, errorCb, reqBody } = data;
  try {
    const { url: freshdeskRedirectUrl, method } = FRESHDESK_REDIRECT_URL;
    const { nonce, state, redirectUri } = reqBody;
    const updatedUrlForFreshdeskRedirect = freshdeskRedirectUrl
      .replace('$nonce$', nonce)
      .replace('$state$', state)
      .replace('$redirectUri$', redirectUri);
    const response = yield call(request, updatedUrlForFreshdeskRedirect, {
      method,
    });
    if (cb) cb(response.redirectUrl);
  } catch (err) {
    if (errorCb) errorCb();
    yield put(showToast(err));
  }
}

export function* fetchBanners({ data }) {
  const { cb } = data;
  try {
    const { url, method } = FETCH_BANNERS_URL;
    const response = yield call(request, url, { method });
    if (cb) cb(response);
  } catch (err) {
    yield put(showToast(err));
  }
}

export function* getMerchantDetails({ data }) {
  try {
    const { cb } = data;
    const { url, method } = GET_MERCHANT_DETAILS_URL;

    const response = yield call(request, url, { method });
    if (cb) cb(response);
    // yield put(saveMerchantDetails(response));
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error(err);
  }
}

export function* fetchProductCards({ data }) {
  const { cb } = data;
  try {
    const { url, method } = FETCH_PRODUCT_CARDS_URL;

    const response = yield call(request, url, { method });
    if (cb && response) cb(response);
  } catch (err) {
    yield put(showToast(err));
  }
}

export function* quickActivateProduct({ data }) {
  const { productName, cb, successCb } = data;
  try {
    const { url, method } = QUICK_ACTIVATE_PRODUCT_URL;
    const updatedUrl = url.replace('$productName$', productName);

    yield call(request, updatedUrl, { method });
    if (successCb) successCb();
  } catch (err) {
    yield put(showToast(err));
  } finally {
    if (cb) cb();
  }
}

export function* getAMDetails({ data }) {
  const { merchantId } = data;
  try {
    const { url, method } = AM_DETAILS_URL;
    const updatedUrl = url.replace('$merchantId$', merchantId);

    const response = yield call(request, updatedUrl, { method });
    const accountManagerList = response.managersList || [];
    sortAccountManagerList(accountManagerList);
    yield put(setAMDetails(accountManagerList));
  } catch (err) {
    yield put(showToast(err));
  }
}
export function* activateEcomProduct({ data }) {
  const { cb, reqBody, errorCb } = data;
  try {
    const { url, method } = PRODUCT_ACTIVATE_URL;

    const options = {
      headers: {
        'Content-type': 'application/json',
      },
      method,
      body: JSON.stringify(reqBody),
    };
    const response = yield call(request, url, options);
    cb(response);
  } catch (err) {
    yield put(showToast(err));
    errorCb(err);
  }
}

export function* fetchAggregatedProductStatus({ data: { cb } }) {
  try {
    const { url, method } = LIVE_PRODUCT_STATUS_URL;
    const response = yield call(request, url, { method });
    if (response) cb(response);
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error(err);
  }
}

export function* getQuickLinksDetails() {
  try {
    const requestURL = QUICK_LINKS_URL;
    const data = yield call(request, requestURL);
    yield put(fetchQuickLinksSuccess(data));
  } catch (err) {
    console.log(err, 'err');
  }
}

export function* generateHcForm({ payload: { email } }) {
  yield put(enableLoaderAction());
  try {
    const {
      url,
      method,
      productType,
      templateIdGamma,
      templateIdProd,
      formType,
    } = HC_FORM;
    const envObj = process.env;
    const options = {
      method,
      body: JSON.stringify({
        product_type: productType,
        template_id:
          envObj.NODE_ENV === PROD || envObj.NODE_ENV === PROD_TEST
            ? templateIdProd
            : templateIdGamma,
        form_type: formType,
        customers: [{ email }],
      }),
    };
    const substituteBaseUrl = process.env.DYNAMIC_FORM;
    const response = yield call(request, url, options, substituteBaseUrl);
    yield put(generateHcFormSucccess(response));
    if (response && response.shortCode) {
      yield* getHcFormData({ payload: { shortCode: response.shortCode } });
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error(err);
    yield put(showToast(err));
  }
  yield put(disableLoaderAction());
}

export function* getHcFormData({ payload: { shortCode } }) {
  try {
    const { method } = HC_FORM;
    const options = {
      method,
    };

    const substituteBaseUrl = process.env.DYNAMIC_FORM;
    const url = `${substituteBaseUrl}/v2/${shortCode}`;
    const response = yield call(makeFetchRequest, url, options);
    yield put(getFormDataSuccess(response));
    yield put(openHcFormAction());
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error(err);
  }
}

/**
 * Saga to trigger banner close api
 *
 * @param {Object} action - The action containing data.
 * @param {Object} action.payload - The payload.
 * @param {string} action.payload.name - The name of the banner.
 * */
export function* closeBanner({ payload }) {
  try {
    const { url, method } = CLOSE_BANNER_URL;
    const finalUrl = `${url}/${payload.name}`;
    const options = { method, useBasePath: true };

    yield call(request, finalUrl, options);
  } catch (err) {
    toast.error(err?.errorMeta?.message);
  }
}

export function* getPayoutProtectInsights({ payload }) {
  try {
    const { url, method } = PAYOUT_PROTECT_INSIGHTS_URL;
    const options = {
      method,
      queryString: payload.reqOptions,
      directResponseReturn: true,
    };
    const responseData = yield call(
      request,
      url,
      options,
      '',
      CUSTOM_BASE_PATH_TYPES.RISKSHIELD_BASE_PATH,
    );
    yield put(getPayoutProtectInsightsSuccessAction(responseData));
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error(err);
  }
}

export function* getPayoutProtectActiveStatus({ payload: { successCb } }) {
  try {
    const { url, method } = PAYOUT_PROTECT_ACTIVE_STATUS_URL;
    const options = {
      method,
      directResponseReturn: true,
    };
    const responseData = yield call(
      request,
      url,
      options,
      '',
      CUSTOM_BASE_PATH_TYPES.RISKSHIELD_BASE_PATH,
    );
    yield put(getPayoutProtectActiveStatusSuccessAction(responseData));
    successCb(responseData);
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error(err);
  }
}

export function* activatePayoutProtect({ payload: { successCb, errorCb } }) {
  try {
    const { url, method } = ACTIVATE_PAYOUT_PROTECT_URL;
    const options = {
      method,
      directResponseReturn: true,
    };
    const responseData = yield call(
      request,
      url,
      options,
      '',
      CUSTOM_BASE_PATH_TYPES.RISKSHIELD_BASE_PATH,
    );
    successCb(responseData);
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error(err);
    errorCb();
  }
}

export function* activateRiskShield({ payload: { successCb, errorCb } }) {
  try {
    const { url, method } = ACTIVATE_RISKSHIELD_URL;
    const options = {
      method,
      directResponseReturn: true,
    };
    const responseData = yield call(
      request,
      url,
      options,
      '',
      CUSTOM_BASE_PATH_TYPES.RISKSHIELD_BASE_PATH,
    );
    successCb(responseData);
  } catch (error) {
    yield put(showToast(error));
    if (errorCb) errorCb(error);
  }
}

export function* getRiskShieldActiveStatus() {
  try {
    const { url, method } = RISK_SHIELD_ACTIVE_STATUS_URL;
    const options = {
      method,
      directResponseReturn: true,
    };
    const responseData = yield call(
      request,
      url,
      options,
      '',
      CUSTOM_BASE_PATH_TYPES.RISKSHIELD_BASE_PATH,
    );
    yield put(getRiskShieldActiveStatusSuccessAction(responseData));
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error(err);
  }
}

export function* quickActivateProductSaga() {
  yield takeEvery(QUICK_ACTIVATE_PRODUCT, quickActivateProduct);
}

export function* fetchProductCardsSaga() {
  yield takeEvery(FETCH_PRODUCT_CARDS, fetchProductCards);
}

export function* fetchBannersSaga() {
  yield takeEvery(FETCH_BANNERS, fetchBanners);
}

export function* fetchProductStatusSaga() {
  yield takeEvery(FETCH_PRODUCT_STATUS, fetchProductStatusData);
}

export function* getSubscriptionStatusSaga() {
  yield takeLatest(GET_SUBSCRIPTION_STATUS, getSubscriptionStatus);
}

export function* fetchTestTokenFromProdSaga() {
  yield takeEvery(FETCH_TEST_TOKEN_FROM_PROD, fetchTestTokenFromProdData);
}

export function* resendEmailVerificationSaga() {
  yield takeEvery(RESEND_EMAIL_VERIFICATION, resendEmailVerificationData);
}

export function* activateProductSaga() {
  yield takeEvery(ACTIVATE_PRODUCTS, activateProduct);
}

export function* validateTokenSaga() {
  yield takeEvery(VALIDATE_TOKEN, validateToken);
}

export function* fetchGammaTokenSaga() {
  yield takeLatest(FETCH_GAMMA_TOKEN, fetchGammaToken);
}

export function* fetchPayoutDashboardConfigSaga() {
  yield takeEvery(
    FETCH_PAYOUT_DASHBOARD_CONFIG,
    fetchPayoutDashboardConfigData,
  );
}

export function* redeemVoucherSaga() {
  yield takeEvery(REDEEM_VOUCHER, redeemVoucher);
}

export function* subscribeWhatsappSaga() {
  yield takeEvery(SUBSCRIBE_WHATSAPP, subscribeWhatsapp);
}

export function* checkWhatsappConsentSaga() {
  yield takeLatest(WHATSAPP_CONSENT, checkWhatsappConsentData);
}

export function* checkPartnerConsentSaga() {
  yield takeLatest(PARTNER_CONSENT, checkPartnerConsent);
}

export function* partnerTncSaga() {
  yield takeLatest(PARTNER_TNC, partnerTnc);
}

export function* freshdeskRedirectSaga() {
  yield takeLatest(FRESHDESK_REDIRECT, freshdeskRedirect);
}

export function* getMerchantDetailsSaga() {
  yield takeLatest(GET_MERCHANT_DETAILS, getMerchantDetails);
}

export function* getAMDetailsSaga() {
  yield takeLatest(GET_ACCOUNT_MANAGER_DETAILS, getAMDetails);
}
export function* activateEcomProductSaga() {
  yield takeEvery(ACTIVATE_ECOM_PRODUCT_ACTION, activateEcomProduct);
}

export function* fetchAggregatedProductStatusSaga() {
  yield takeLatest(
    FETCH_AGGREGATED_PRODUCT_STATUS,
    fetchAggregatedProductStatus,
  );
}

export function* getQuickLinksDetailsSaga() {
  yield takeLatest(FETCH_QUICK_LINKS, getQuickLinksDetails);
}

export function* generateHcFormSaga() {
  yield takeLatest(FETCH_HELPCENTER_FORM, generateHcForm);
}

export function* closeBannerSaga() {
  yield takeLatest(CLOSE_BANNER, closeBanner);
}

export function* getPayoutProtectInsightsSaga() {
  yield takeLatest(PAYOUT_PROTECT_INSIGHTS, getPayoutProtectInsights);
}

export function* getPayoutProtectActiveStatusSaga() {
  yield takeLatest(PAYOUT_PROTECT_ACTIVE_STATUS, getPayoutProtectActiveStatus);
}

export function* activatePayoutProtectSaga() {
  yield takeLatest(ACTIVATE_PAYOUT_PROTECT, activatePayoutProtect);
}

export function* activateRiskShieldSaga() {
  yield takeLatest(ACTIVATE_RISKSHIELD, activateRiskShield);
}

export function* getRiskShieldActiveStatusSaga() {
  yield takeLatest(RISK_SHIELD_ACTIVE_STATUS, getRiskShieldActiveStatus);
}

export default function* landingPageSaga() {
  const sagas = [
    fetchProductStatusSaga,
    getSubscriptionStatusSaga,
    fetchTestTokenFromProdSaga,
    resendEmailVerificationSaga,
    activateProductSaga,
    validateTokenSaga,
    fetchGammaTokenSaga,
    fetchPayoutDashboardConfigSaga,
    redeemVoucherSaga,
    subscribeWhatsappSaga,
    checkWhatsappConsentSaga,
    freshdeskRedirectSaga,
    fetchBannersSaga,
    getMerchantDetailsSaga,
    fetchProductCardsSaga,
    quickActivateProductSaga,
    checkPartnerConsentSaga,
    partnerTncSaga,
    getAMDetailsSaga,
    activateEcomProductSaga,
    fetchAggregatedProductStatusSaga,
    getQuickLinksDetailsSaga,
    generateHcFormSaga,
    closeBannerSaga,
    getPayoutProtectInsightsSaga,
    getPayoutProtectActiveStatusSaga,
    activatePayoutProtectSaga,
    activateRiskShieldSaga,
    getRiskShieldActiveStatusSaga,
  ];

  yield all(
    sagas.map(saga =>
      // eslint-disable-next-line func-names
      spawn(function*() {
        while (true) {
          try {
            yield call(saga);
            break;
          } catch (e) {
            // eslint-disable-next-line no-console
            console.log(e);
          }
        }
      }),
    ),
  );
}
